import { FiasFields, FiasStructureStatuses } from '../types';
import { abbreviations } from '../constants/abbreviations';
import { estateStatuses, flatTypes, roomTypes, houseAddTypes, houseTypes } from '../constants/dataTypes';
import { FiasData } from './FiasData';
var FiasAddressElement = /** @class */ (function () {
    function FiasAddressElement(type, name, data) {
        var _this = this;
        this.type = type;
        this.name = name;
        this.data = data;
        this.isTypeMatchField = function (field) {
            var data = _this.data;
            if (data && data.abbreviation) {
                return FiasAddressElement.MATCHING_TYPES[data.abbreviation] === field;
            }
            return false;
        };
        this.removeData = function () {
            delete _this.data;
        };
        this.isEqualTo = function (element) {
            if (element && element.fiasId) {
                return _this.fiasId === element.fiasId;
            }
            return false;
        };
    }
    Object.defineProperty(FiasAddressElement.prototype, "isFederalCity", {
        get: function () {
            if (!this.fiasId) {
                return false;
            }
            return FiasAddressElement.FEDERAL_CITIES.indexOf(this.fiasId) > -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasAddressElement.prototype, "isMoscowRegion", {
        get: function () {
            if (!this.fiasId) {
                return false;
            }
            return this.fiasId === FiasAddressElement.MOSCOW_REGION;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasAddressElement.prototype, "isUnknown", {
        get: function () {
            return this.fiasId === FiasAddressElement.UNKNOWN_FIAS_ID;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasAddressElement.prototype, "fiasData", {
        get: function () {
            if (this.data && this.data.data) {
                return this.data.data;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasAddressElement.prototype, "fiasId", {
        get: function () {
            if (this.data) {
                return this.data.fiasId;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasAddressElement.prototype, "editableString", {
        get: function () {
            switch (this.type) {
                case FiasFields.garhouse:
                case FiasFields.house:
                case FiasFields.room:
                case FiasFields.region:
                    return this.getText();
                default:
                    return this.name;
            }
        },
        enumerable: false,
        configurable: true
    });
    FiasAddressElement.prototype.getText = function (withoutType) {
        if (withoutType === void 0) { withoutType = false; }
        var _a = this, name = _a.name, data = _a.data;
        var result = '';
        if (!name) {
            return '';
        }
        if (data) {
            var abbreviation = data.abbreviation, official = data.official, number = data.number;
            if (abbreviation) {
                var type = !withoutType ? abbreviations[abbreviation] || abbreviation : '';
                switch (abbreviation) {
                    case 'п':
                        result = !withoutType
                            ? (this.type === FiasFields.district ? 'поселение' : 'поселок') + " " + name
                            : "" + name;
                        break;
                    default:
                        result = type + " " + name;
                }
            }
            if (FiasData.isRegion(this.fiasData)) {
                result = official;
            }
            if (FiasData.isStead(this.fiasData)) {
                result = 'земельный участок ' + number;
            }
            if (FiasData.isHouse(this.fiasData)) {
                var _b = this.fiasData, estateStatus = _b.estateStatus, structureStatus = _b.structureStatus, structureNumber = _b.structureNumber, buildingNumber = _b.buildingNumber, number_1 = _b.number;
                result = result + " " + estateStatuses[estateStatus];
                if (number_1) {
                    result = result + " " + number_1;
                }
                if (structureStatus && structureStatus !== FiasStructureStatuses.None && structureNumber) {
                    switch (structureStatus) {
                        case FiasStructureStatuses.Structure:
                            result = result + " \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 " + structureNumber;
                            break;
                        case FiasStructureStatuses.Construction:
                            result = result + " c\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435 " + structureNumber;
                            break;
                        case FiasStructureStatuses.Liter:
                            result = result + " \u043B\u0438\u0442\u0435\u0440\u0430 " + structureNumber;
                            break;
                    }
                }
                if (buildingNumber) {
                    result = result + " \u043A\u043E\u0440\u043F\u0443\u0441 " + buildingNumber;
                }
            }
            if (FiasData.isGarHouse(this.fiasData)) {
                var _c = this.fiasData, houseNum = _c.houseNum, houseType = _c.houseType, addNum1 = _c.addNum1, addNum2 = _c.addNum2, addType1 = _c.addType1, addType2 = _c.addType2;
                result = houseNum !== null && houseNum !== void 0 ? houseNum : '';
                if (houseType && houseNum) {
                    result = houseTypes[houseType] + " " + houseNum;
                }
                if (addType1 && addNum1) {
                    result += " " + houseAddTypes[addType1] + " " + addNum1;
                }
                if (addType2 && addNum2) {
                    result += " " + houseAddTypes[addType2] + " " + addNum2;
                }
            }
            if (FiasData.isRoom(this.fiasData)) {
                var _d = this.fiasData, flatType = _d.flatType, flatFiasId = _d.flatFiasId, roomType = _d.roomType, roomNumber = _d.roomNumber;
                if (flatType) {
                    result = flatTypes[flatType] + " " + name;
                    if (flatFiasId && roomType && roomNumber) {
                        result += " " + roomTypes[roomType] + " " + roomNumber;
                    }
                }
                else {
                    result = name;
                }
            }
        }
        return result.trim() || name;
    };
    Object.defineProperty(FiasAddressElement.prototype, "verifiableData", {
        get: function () {
            var _a = this, type = _a.type, data = _a.data, fiasId = _a.fiasId;
            if (data) {
                var name_1 = data.name, abbreviation = data.abbreviation, number = data.number, structureNumber = data.structureNumber, buildingNumber = data.buildingNumber, structureStatus = data.structureStatus, estateStatus = data.estateStatus, houseNum = data.houseNum, houseType = data.houseType, addNum1 = data.addNum1, addType1 = data.addType1, addNum2 = data.addNum2, addType2 = data.addType2, flatFiasId = data.flatFiasId, flatNumber = data.flatNumber, flatType = data.flatType, roomNumber = data.roomNumber, roomType = data.roomType;
                switch (type) {
                    case FiasFields.house:
                        return {
                            number: number,
                            structureNumber: structureNumber,
                            structureStatus: structureStatus,
                            estateStatus: estateStatus,
                            buildingNumber: buildingNumber,
                            fiasId: fiasId,
                        };
                    case FiasFields.garhouse:
                        return {
                            houseNum: houseNum,
                            houseType: houseType,
                            addNum1: addNum1,
                            addType1: addType1,
                            addNum2: addNum2,
                            addType2: addType2,
                            fiasId: fiasId,
                        };
                    case FiasFields.room:
                        return {
                            flatFiasId: flatFiasId,
                            flatNumber: flatNumber,
                            flatType: flatType,
                            roomNumber: roomNumber,
                            roomType: roomType,
                            fiasId: fiasId,
                        };
                    default:
                        return {
                            name: name_1,
                            abbreviation: abbreviation,
                            fiasId: fiasId,
                        };
                }
            }
            return {
                name: this.name,
                fiasId: fiasId,
            };
        },
        enumerable: false,
        configurable: true
    });
    // Types (abbrevs) that match fields labels
    FiasAddressElement.MATCHING_TYPES = {
        'р-н': FiasFields.district,
        г: FiasFields.city,
        нп: FiasFields.settlement,
        ул: FiasFields.street,
    };
    FiasAddressElement.FEDERAL_CITIES = [
        '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
        'c2deb16a-0330-4f05-821f-1d09c93331e6',
        '6fdecb78-893a-4e3f-a5ba-aa062459463b',
        '63ed1a35-4be6-4564-a1ec-0c51f7383314',
    ];
    FiasAddressElement.MOSCOW_REGION = '29251dcf-00a1-4e34-98d4-5c47484a36d4'; // Московская область
    FiasAddressElement.UNKNOWN_FIAS_ID = '00000000-0000-0000-0000-000000000000';
    return FiasAddressElement;
}());
export { FiasAddressElement };
